export default __webpack_public_path__ + "img/946060a0fe72180034c416944d828563.png";